<template>
  <div class="slide" :style="slide.backgroundColor ? `background-color: ${slide.backgroundColor};` : 'transparent;'">
    <div class="bg-full" v-if="slide.photo" :style="`background-image: url(${slide.photo})`"></div>
    <div class="audio">
      <a href="#" @click="play" :class="{'play': !isPlaying, 'pause': isPlaying}"></a>
      <div id="waveform"></div>
    </div>

    <app-footer :footer="slide.footnote" :details="slide.details"></app-footer>
  </div>
</template>

<script>
import WaveSurfer from "wavesurfer.js";
import AppFooter from './Footer'

export default {
  props: ["slide", "photo", "audio", "footnote", "details"],
  data() {
    return {
      isPlaying: false
    }
  },
  components: {AppFooter},
  methods: {
    play() {
      this.wavesurfer.playPause();
      this.isPlaying = !this.isPlaying;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.wavesurfer = WaveSurfer.create({
        container: "#waveform",
        waveColor: "#cccccc",
        progressColor: "#cc0000"
      });
      this.wavesurfer.load(this.audio);
    });
  }
};
</script>

<style scoped>
.slide {
    position: relative;
}
.audio {
  width: 90%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  z-index: 100;
}
.bg-full {
  position: absolute;
  z-index: -1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.5; 
  filter: blur(35px);
}
a.play, a.pause {
  display: inline-block;
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background:rgba(0,0,0,0.4);
  cursor: pointer;
  transition: .3s all ease;
}
a.play:hover, a.pause:hover {
  background: rgba(204,0,0,0.4);
}
a.play:before {
  content: "";
  display: block;
  position: absolute;
  width: 0; 
  height: 0; 
  border-style: solid;
  border-width: 15px 0 15px 30px;
  border-color: transparent transparent transparent #ffffff;
  top: 15px;
  left: 20px;
}
a.pause:before {
  content: '';
  width: 5px;
  height: 30px;
  background: #fff;
  position: absolute;
  left: 20px;
  top: 15px;
}
a.pause:after {
  content: '';
  width: 5px;
  height: 30px;
  background: #fff;
  position: absolute;
  right: 20px;
  top: 15px;
}
</style>